import Services from '../services/Services';

// API credentials for getting public token
const TOKEN_API_KEY = process.env.REACT_APP_TOKEN_API_KEY || '';
const TOKEN_API_SECRET = process.env.REACT_APP_TOKEN_API_SECRET || '';

let cachedPublicToken: string | null = null;
let tokenPromise: Promise<string | null> | null = null;

/**
 * Gets a public token for accessing public API endpoints
 * Uses caching to avoid multiple requests
 * @returns Promise<string | null> - The public token or null if failed
 */
export const getPublicToken = async (): Promise<string | null> => {
  // Return cached token if available
  if (cachedPublicToken) {
    return cachedPublicToken;
  }

  // Return existing promise if one is in progress
  if (tokenPromise) {
    return tokenPromise;
  }

  // Check if credentials are available
  if (!TOKEN_API_KEY || !TOKEN_API_SECRET) {
    return null;
  }

  // Create new promise for token request
  tokenPromise = (async () => {
    try {
      const response = await Services.GetToken(TOKEN_API_KEY, TOKEN_API_SECRET);
      if (response.data.status && response.data.result?.token) {
        cachedPublicToken = response.data.result.token;
        return cachedPublicToken;
      }
      return null;
    } catch (error) {
      return null;
    } finally {
      // Clear promise so we can retry if needed
      tokenPromise = null;
    }
  })();

  return tokenPromise;
};

/**
 * Clears the cached public token (useful for testing or token refresh)
 */
export const clearPublicTokenCache = (): void => {
  cachedPublicToken = null;
  tokenPromise = null;
};

